export default function reducer (state = {
  updated: Date.now()
}, action) {
  switch (action.type) {
    case 'SET_CONFIG':
      return {
        ...state,
        ...action.payload
      }
    default: {
      return {
        ...state
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/configReducer.js